module.exports = __webpack_public_path__ + "img/img-8.a64085e9.png";